var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 3.30977C3.6 2.86794 3.95817 2.50977 4.4 2.50977H15.6C16.0418 2.50977 16.4 2.86794 16.4 3.30977V17.7098C16.4 18.1516 16.0418 18.5098 15.6 18.5098H4.4C3.95817 18.5098 3.6 18.1516 3.6 17.7098V3.30977ZM5.2 4.10977V16.9098H14.8V4.10977H5.2Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17.7098C2 17.2679 2.35817 16.9098 2.8 16.9098H17.2C17.6418 16.9098 18 17.2679 18 17.7098C18 18.1516 17.6418 18.5098 17.2 18.5098H2.8C2.35817 18.5098 2 18.1516 2 17.7098Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51016 6.30977H8.79016V7.58977H7.51016V6.30977Z",
    fill: "#4F5E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51016 9.90977H8.79016V11.1898H7.51016V9.90977Z",
    fill: "#4F5E71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51016 13.5098H8.79016V14.7898H7.51016V13.5098Z",
    fill: "#4F5E71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1195 13.5098H12.3995V14.7898H11.1195V13.5098Z",
    fill: "#4F5E71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1195 9.9498H12.3995V11.2298H11.1195V9.9498Z",
    fill: "#4F5E71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1195 6.3498H12.3995V7.6298H11.1195V6.3498Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIcon);
export default __webpack_public_path__ + "static/media/companiesIcon.206eb89c2ffbbf5642bd3888f1c63d84.svg";
export { ForwardRef as ReactComponent };